// extracted by mini-css-extract-plugin
export default {"hintList":"IP_hintList__VublC"};